module.exports = {
    DOZ_GLOBAL: '__DOZ_GLOBAL_COMPONENTS__',
    DOZ_SSR_PATH: '__DOZ_SSR_PATH__'
};